
import React from 'react';
import { Button } from "@/components/ui/button";
import MatchDetails from '../matches/MatchDetails';
import { Match } from '../types/head-to-head';

interface MatchListProps {
  showMatches: boolean;
  setShowMatches: (show: boolean) => void;
  matches: Match[];
  selectedMatchIndex: number | null;
}

const MatchList: React.FC<MatchListProps> = ({
  showMatches,
  setShowMatches,
  matches,
  selectedMatchIndex
}) => {
  // Create a unique key for each match
  const getMatchKey = (match: Match) => {
    return `${match.Date}_${match.HomeTeam}_${match.AwayTeam}`;
  };

  // Remove duplicates using Set and matchKey
  const uniqueMatches = Array.from(
    new Map(matches.map(match => [getMatchKey(match), match])).values()
  );

  // Sort matches by date - simple string comparison without any format assumption
  const sortedMatches = [...uniqueMatches].sort((a, b) => {
    return b.Date.localeCompare(a.Date);
  });

  return (
    <>
      <div className="flex justify-end mb-4">
        <Button
          variant="ghost"
          onClick={() => setShowMatches(!showMatches)}
          className="text-sm px-2 py-1 h-auto"
        >
          {showMatches ? 'Hide matches' : 'Show matches'}
        </Button>
      </div>

      {selectedMatchIndex !== null && sortedMatches[selectedMatchIndex] && (
        <MatchDetails match={sortedMatches[selectedMatchIndex]} />
      )}

      {showMatches && (
        <div className="space-y-4 mb-8">
          {sortedMatches.map((match, index) => (
            <MatchDetails 
              key={getMatchKey(match)} 
              match={match} 
            />
          ))}
        </div>
      )}
    </>
  );
};

export default MatchList;
